export const FETCH_ACTOR = 'fetchActor'
